// Icon imports
import { TbBrandLinkedinFilled } from "react-icons/tb";
import { FaGithubSquare } from "react-icons/fa";

// Components import
import EmailForm from "../form/EmailForm";

function ContactMe() {
  return (
    <div id="contact" name="contact" className="project-animate">
        <h2 className="heading-2"> Contact Me </h2>
        <div className="center">
            <div className="paragraph-margin-bottom">
                Let's connect through my LinkedIn and Github or you can send me the email!
            </div>
        </div>

        <div className="center">
            <div className="contact-line">
                <hr className="line" />
                <span className="contact-icon"> 
                    <a href="https://www.linkedin.com/in/khoadangnguyen2005/" target="_blank" rel="noopener noreferrer" className="linkedin"> <TbBrandLinkedinFilled/> </a> 
                    <a href="https://github.com/Dang-Khoa-Nguyen" target="_blank" rel="noopener noreferrer" className="github"><FaGithubSquare/> </a>
                </span>
                <hr className="line" />
            </div>
        </div>
        <EmailForm/>
    </div>
  );
}

export default ContactMe;
